<template>
  <div class="form">
    <label>
      {{ placeholder }}
    </label>
    <input
      :id="id"
      :type="type"
      class="cr_form_input"
      :placeholder="suggest"
      :value="value"
      @input="emitValue($event.target.value)"
      style=""
    />
  </div>
</template>

<script>
export default {
  props: ['value', 'type', 'placeholder', 'id', 'suggest'],
  methods: {
    emitValue(value) {
      this.$emit('input', value)
    },
  },
}
</script>

<style scoped>
.form label {
  font: 400 0.875rem/1.375rem 'Open Sans';
}
input {
  padding-left: 15px;
  outline: none;
}

input:focus {
  box-shadow: 0px 0px 0px 1px var(--primary_color);
}
input:focus {
  box-shadow: 0px 0px 0px 1px var(--primary_color);
}
.cr_form_input {
  border: 1px solid #b7b8ba;
  padding-bottom: 0;
  min-height: 50px;
  border-radius: var(--button_radius_4);
  margin-bottom: 20px;
}
</style>
